import { ChallengesState } from '@/redux/reducers/challenge';
import { RootState } from '@/redux/store';
import { createSelector } from '@reduxjs/toolkit';

export const getUserChallengeSelector = createSelector(
  (state: RootState) => state.challenges,
  ({ userChallenge }: ChallengesState) => userChallenge
);

export const getCompanyChallengeSelector = createSelector(
  (state: RootState) => state.challenges,
  ({ companyChallenge }: ChallengesState) => companyChallenge
);

export const getChallengesLoading = createSelector(
  (state: RootState) => state.challenges,
  ({ loading }: ChallengesState) => loading
);

export const getHasFetchedUserChallenge = createSelector(
  (state: RootState) => state.challenges,
  ({ hasFetchedUserChallenge }: ChallengesState) => hasFetchedUserChallenge
);
